import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalMayorEdad({ reset }) {
  const pdfUrl =
    'https://www.dges.edu.uy/sites/default/files/2024-12/Liceos%20con%20Plan%201994%20%E2%80%93%20actualizado%202025_0.pdf';

  return (
    <Container className="form-container text-center">
      <h2 className="form-title">Fuera de rango de edad</h2>
      <p>
        Actualmente las becas que ofrece la Fundación 3F están destinadas exclusivamente a personas de entre 18 y 29 años.
      </p>
      <p>
        Te sugerimos explorar la opción de cursar en la modalidad "Libre Asistido" en un liceo de tu preferencia. En el
        siguiente link encontrarás la lista de liceos que la ofrecen.
      </p>
      <div className="d-flex flex-column flex-md-row justify-content-center gap-2 mt-3">
        <Button as="a" href={pdfUrl} target="_blank" rel="noopener noreferrer" variant="primary">
          Ver listado (PDF)
        </Button>
        <Button variant="secondary" onClick={reset}>
          Reiniciar formulario
        </Button>
      </div>
    </Container>
  );
}